module.exports = global["p2"] = require("-!./p2.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser-ce/build/custom/p2.js
// module id = 524
// module chunks = 3